import PropTypes from 'prop-types';
import React, { useContext, useRef, useState } from 'react';
import { BOOKABLE_AT_REDEMPTION } from '../../../../config/text/text';
import ThemeContext from '../../../../providers/ThemeProvider';
import WowModal from '../../../WowModal';
import BookingCalendarCell from './BookingCalendarCell';

const BookingCalendarCells = ({
  cells,
  isBookingCalendarOnRedemption,
  onSelect,
  onMonthChange,
}) => {
  const theme = useContext(ThemeContext);
  const [showModal, setShowModal] = useState(false);
  const ref = useRef(null);

  const onClickCell = () => {
    setShowModal(true);
  };

  return (
    <>
      <div className="booking-calendar" ref={ref}>
        <WowModal
          ariaLabelledBy="id-subscribe"
          backdropClassName="remove-backdrop"
          container={ref.current}
          extraClasses="bcor-message"
          setShowModal={setShowModal}
          showModal={showModal}
          size="md"
          title=""
        >
          {isBookingCalendarOnRedemption && (
            <p>
              <b>{BOOKABLE_AT_REDEMPTION}</b>
            </p>
          )}
        </WowModal>
        <div className="booking-calendar__grid">
          {cells.map((cell, index) => (
            <BookingCalendarCell
              cell={cell}
              index={index}
              isBookingCalendarOnRedemption={isBookingCalendarOnRedemption}
              key={index}
              onClickCell={onClickCell}
              onMonthChange={onMonthChange}
              onSelect={onSelect}
            />
          ))}
        </div>
      </div>
      <style jsx>{`
        .booking-calendar {
          margin-bottom: 8px;
          position: relative;
        }
        .booking-calendar__grid {
          display: flex;
          flex-wrap: wrap;
          border: 1px solid ${theme.colors.primary};
        }
      `}</style>
    </>
  );
};

BookingCalendarCells.propTypes = {
  cells: PropTypes.array,
  isBookingCalendarOnRedemption: PropTypes.bool,
  onMonthChange: PropTypes.func,
  onSelect: PropTypes.func,
};

BookingCalendarCells.defaultProps = {
  cells: [],
  isBookingCalendarOnRedemption: false,
  onMonthChange: () => false,
  onSelect: () => false,
};

export default BookingCalendarCells;
